export const dispatch = (eventName: string, data: Record<string, any>, isPlugin: boolean) => {
    if (isPlugin && window?.postRobot) {
        window?.postRobot?.sendToParent?.(eventName, data)
        return
    }
    window.dispatchEvent(new CustomEvent(eventName, { detail: data }))

}

export const listen = (eventName: string, callback: (data: any) => void, isPlugin: boolean, once = false) => {
    if (isPlugin && window?.postRobot) {
        const listener = window?.postRobot?.[once ? 'once' : 'on']?.(eventName, e => callback(e.data))
        return { remove : () => listener.cancel() }
    }
    const controller = new AbortController()
    window.addEventListener(eventName, (e: CustomEvent) => callback(e.detail), { once, signal: controller.signal })
    return { remove: () => controller.abort() }
}